import React from 'react';

// Geist font family with fallbacks
const GEIST_FONT_FAMILY = '"Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  children?: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'default',
  size = 'default',
  className,
  children,
  style,
  ...props
}) => {
  const baseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0.375rem',
    fontSize: '0.875rem',
    fontWeight: '500',
    fontFamily: GEIST_FONT_FAMILY,
    transition: 'all 0.2s ease-in-out',
    cursor: 'pointer',
    border: 'none',
    textDecoration: 'none',
    outline: 'none',
    ...getVariantStyles(variant),
    ...getSizeStyles(size),
  };

  return (
    <button
      style={{
        ...baseStyles,
        ...style,
      }}
      {...props}
    >
      {children}
    </button>
  );
};

function getVariantStyles(variant: string) {
  switch (variant) {
    case 'outline':
      return {
        backgroundColor: 'transparent',
        border: '1px solid #d1d5db',
        color: '#374151',
      };
    case 'ghost':
      return {
        backgroundColor: 'transparent',
        color: '#374151',
      };
    default:
      return {
        backgroundColor: '#3b82f6',
        color: 'white',
      };
  }
}

function getSizeStyles(size: string) {
  switch (size) {
    case 'sm':
      return {
        height: '2rem',
        paddingLeft: '0.75rem',
        paddingRight: '0.75rem',
        fontSize: '0.75rem',
      };
    case 'lg':
      return {
        height: '2.75rem',
        paddingLeft: '2rem',
        paddingRight: '2rem',
        fontSize: '1rem',
      };
    case 'icon':
      return {
        height: '2.5rem',
        width: '2.5rem',
        padding: 0,
      };
    default:
      return {
        height: '2.5rem',
        paddingLeft: '1rem',
        paddingRight: '1rem',
      };
  }
} 